const escapeHTML = (unescaped: string): string => {
  return unescaped
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/'/g, "&#39;")
    .replace(/"/g, "&quot;");
};

const buildGoogleAnalyticsTag = (componentName: string, componentDetails: string, index?: number): string =>
  escapeHTML(`${componentName} -_- ${index ? index + 1 : 1} -_- ${componentDetails}`);

export default buildGoogleAnalyticsTag;
